export function isValidEmail(email: string, isRequired: boolean = true): boolean {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!isRequired) return email === '' || re.test(email)
  return email !== '' && re.test(email)
}
